// extracted by mini-css-extract-plugin
module.exports = {"container":"i_C1","size-l":"i_C2","size-m":"i_C3","size-s":"i_C4"};